<template>
  <!-- TODO refactor the `displayTicket` method -->
  <NewTranslation
    class="banner is-valid"
    v-on:click="() => displayTicket"
    v-if="!loading && qualified"
    path="banner.benefits.available"
  />
  <router-link v-else-if="!loading" :to="{ name: $namedRoutes.booking }">
    <NewTranslation class="banner is-invalid" path="banner.benefits.notAvailable" />
  </router-link>
</template>

<script>
import { mapActions } from 'vuex';
import NewTranslation from '@/components/i18n/NewTranslation';
import MobilePaymentApi from '@/app/utils/MobilePaymentApi';

export default {
  components: { NewTranslation },
  props: {
    useTriggerRequestReview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      qualified: false,
    };
  },
  created() {
    this.userQualifiedBenefits()
      .then(result => {
        this.qualified = result.qualified;
      })
      .finally(() => {
        this.loading = false;
        if (this.qualified && this.useTriggerRequestReview) {
          if (MobilePaymentApi.hasMobilePaymentApi()) {
            MobilePaymentApi.triggerRequestReview();
          }
        }
      });
  },
  methods: {
    ...mapActions(['userQualifiedBenefits']),
    displayTicket() {
      this.$router.push({
        name: this.$namedRoutes.transactionOverview,
        query: { openFirstValidTicket: true },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.banner
    display: flex
    justify-content: center
    align-items: center
    background-color: #112
    height: 60px
    color: #fff
    text-decoration: underline
.is-valid
    background-color: #27D190
.is-invalid
    background-color: #DE3D36
</style>
